import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Wrapper = styled.div<{ selected?: boolean }>`
    display: flex;
    margin: ${theme.space[2]}px 0;
    border: 1px solid ${({ selected }) => (selected ? theme.colors.primaryBlack : theme.colors.grey2)};
    border-radius: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Image = styled.div`
    width: 90px;
    img {
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
    }

    &,
    img {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
`;

export const Content = styled.div`
    padding: ${theme.space[3]}px;
`;

export const Actions = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 80px;
    margin-left: auto;
    padding: ${theme.space[2]}px;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: auto;
    }
`;

export const Title = styled.h2`
    margin: 0;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    letter-spacing: 0;
    line-height: 2.4rem;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
`;
